import React, { useState, useEffect } from "react";
import {
  Select,
  Table,
  Tag,
  Tooltip,
  Modal,
  Button,
  Pagination,
  Input,
} from "antd";
import societies_icn from "../../../assets/images/societies-icn.svg";
import revenue_icn from "../../../assets/images/revenue.svg";
import members_icn from "../../../assets/images/members.svg";
import registrations_icn from "../../../assets/images/registrations.svg";
import switch_icn from "../../../assets/images/switch.png"; 
import Header from "../common/Header/index";
import "./dashboard.scss";
import moment from "moment";

const DashboardComponent = (props) => {
  const [isMobile, setIsMobile] = useState(false);
  const [isActivityModalOpen, setIsActivityModalOpen] = useState(false);
  const [currentActivityPage, setCurrentActivityPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState(""); 
  const [filteredActivities, setFilteredActivities] = useState([]); 
  const pageSize = 5;

  const {
    visitorData,
    society_count,
    complaintData,
    presidentActivityDataList,
  } = props;

  useEffect(() => {
    if (presidentActivityDataList) {
      const filtered = presidentActivityDataList.filter(
        (item) =>
          (item.title &&
            item.title.toLowerCase().includes(searchQuery.toLowerCase())) ||
          (item.description &&
            item.description.toLowerCase().includes(searchQuery.toLowerCase()))
      );
      setFilteredActivities(filtered);
      setCurrentActivityPage(1);  
    }
  }, [searchQuery, presidentActivityDataList]);

  const totalComplaints = society_count?.total_complain_count || 0;
  const totalUsers = society_count?.total_Active_member_count || 0;
  const newUsers = society_count?.this_month_active_members_count || 0;
  const todaysVisitor = society_count?.total_visitor_count || 0;

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleCloseModal = () => {
    setIsActivityModalOpen(false);
    setSearchQuery("");
  };

  function formatPhoneNumber(phoneNumber) {
    if (typeof phoneNumber === "string") {
      return phoneNumber
        .replace(/^\+?(\d{2})/, "")
        .replace(/(\d{5})(\d{5})/, "$1 $2");
    } else if (typeof phoneNumber === "number") {
      return String(phoneNumber)
        .replace(/^\+?(\d{2})/, "")
        .replace(/(\d{5})(\d{5})/, "$1 $2");
    }
    return "N/a";
  }

  const complaints_table_data = complaintData?.map((item, index) => ({
    key: index + 1,
    content: item.content,
    flatNumber: item.flatNumber || "N/a",
    wingName: item.wingName || "N/a",
    owner: item.owner || "N/a",
    status: item.status,
    priority: item.priority || "N/a",
    societyName: item.societyName || "N/a",
    date: moment(item.date).format("DD/MM/YYYY"),
  }));

  const complaints_table_columns = [
    {
      title: "Sr. No.",
      dataIndex: "key",
      key: "key",
      render: (text) => <span>{text.toString().padStart(2, "0")}</span>,
    },
    {
      title: "Complaint",
      dataIndex: "content",
      key: "content",
      render: (text) => {
        const capitalizedText = text.charAt(0).toUpperCase() + text.slice(1);
        return (
          <Tooltip placement="top" title={capitalizedText}>
            <div className="complaint-container">
              <p
                style={{
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {capitalizedText}
              </p>
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: "Owner",
      dataIndex: "owner",
      key: "owner",
      render: (name) =>
        name
          ? name
              .split(" ")
              .map(
                (word) =>
                  word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
              )
              .join(" ")
          : "",
    },
    {
      title: "Wing",
      dataIndex: "wingName",
      key: "wingName",
      render: (priority) =>
        priority
          ? priority.charAt(0).toUpperCase() + priority.slice(1).toLowerCase()
          : "",
    },
    {
      title: "Flat Number",
      dataIndex: "flatNumber",
      key: "flatNumber",
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Priority Level",
      dataIndex: "priority",
      key: "priority",
      render: (priority) =>
        priority
          ? priority.charAt(0).toUpperCase() + priority.slice(1).toLowerCase()
          : "",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        const formattedStatus =
          status.charAt(0).toUpperCase() + status.slice(1);
        const color =
          status === "pending"
            ? "red"
            : status === "In progress"
            ? "blue"
            : "green";
        return <Tag color={color}>{formattedStatus}</Tag>;
      },
    },
  ];

  const visitor_table_data = visitorData?.map((item, index) => ({
    key: index + 1,
    content: item.reason,
    visitorName: item.visitorName || "N/a",
    mobileNumber: item.visitorPhoneNumber
      ? formatPhoneNumber(item.visitorPhoneNumber)
      : "N/a",
    wingName: item.wingName || "N/a",
    flatNumber: item.flatNumber,
    inTime: item.in_time || "N/a",
    outTime: item.out_time || "N/a",
    vehicleNumber: item.vehicle_number[0] || "N/a",
  }));

  const visitor_table_columns = [
    {
      title: "Sr. No.",
      dataIndex: "key",
      key: "key",
      render: (text) => <span>{text.toString().padStart(2, "0")}</span>,
    },
    {
      title: "Purpose Of Visit",
      dataIndex: "content",
      key: "content",
      render: (text) => {
        const capitalizedText = text.charAt(0).toUpperCase() + text.slice(1);
        return (
          <Tooltip placement="top" title={capitalizedText}>
            <div className="complaint-container">
              <p
                style={{
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {capitalizedText}
              </p>
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: "Visitor Name",
      dataIndex: "visitorName",
      key: "visitorName",
      render: (priority) =>
        priority
          ? priority.charAt(0).toUpperCase() + priority.slice(1).toLowerCase()
          : "",
    },
    {
      title: "Mobile Number",
      dataIndex: "mobileNumber",
      key: "mobileNumber",
    },
    {
      title: "Visited Wing",
      dataIndex: "wingName",
      key: "wingName",
      render: (priority) =>
        priority
          ? priority.charAt(0).toUpperCase() + priority.slice(1).toLowerCase()
          : "",
    },
    {
      title: "Visited Flat",
      dataIndex: "flatNumber",
      key: "flatNumber",
    },
    {
      title: "In Time",
      dataIndex: "inTime",
      key: "inTime",
    },
    {
      title: "Out Time",
      dataIndex: "outTime",
      key: "outinTime",
    },
    {
      title: "Vehicle Number",
      dataIndex: "vehicleNumber",
      key: "vehicleNumber",
      render: (vehicleNumber) =>
        vehicleNumber ? vehicleNumber.toUpperCase() : "",
    },
  ];

  const paginatedActivities = filteredActivities.slice(
    (currentActivityPage - 1) * pageSize,
    currentActivityPage * pageSize
  );

  return (
    <>
      <div className="dashboard-main">
        <Header title="Dashboard" />

        <div className="dashboard-first">
          <div className="overview">
            <div className="overview-top">
              <div className="top-left-section">
                <span className="first-text">Key Metrics Overview</span>
                <span className="second-text">
                  Get a snapshot of your society’s current status with these key
                  metrics. Track performance, engagement, and overall health of
                  your society, enabling data-driven decisions for improvements
                  and growth.
                </span>
              </div>
              <div className="top-right-section">
                <Select
                  showSearch
                  className="select-month"
                  placeholder="This Month"
                  optionFilterProp="children"
                  defaultValue={"This Month"}
                  disabled
                />
              </div>
            </div>
            <div className="overview-bottom">
              <div className="cardo-1 cardo">
                <img src={societies_icn} alt="" />
                <h3>{totalUsers}</h3>
                <p>Total Users</p>
              </div>
              <div className="cardo-2 cardo">
                <img src={revenue_icn} alt="" />
                <h3>{newUsers}</h3>
                <p>New Users</p>
              </div>
              <div className="cardo-3 cardo">
                <img src={members_icn} alt="" />
                <h3>{totalComplaints}</h3>
                <p>Complaints</p>
              </div>
              <div className="cardo-4 cardo">
                <img src={registrations_icn} alt="" />
                <h3>{todaysVisitor}</h3> <p> Today's Visitor</p>
              </div>
            </div>
          </div>
        </div>
        <div
          className="dashboard-second"
          style={{ flexDirection: "column", backgroundColor: "#fff" }}
        >
          <div className="todays-visitor">
            <h2 style={{ margin: "10px" }}>Complaints</h2>
            <Table
              dataSource={complaints_table_data}
              columns={complaints_table_columns}
              pagination={{
                pageSize: 5,
                position: ["bottomCenter"],
                showSizeChanger: false,
              }}
              scroll={{ x: "max-content" }}
              className="society-table"
              style={{ padding: "10px" }}
            />
          </div>
        </div>
        <div
          className="table-bottom"
          style={{
            display: "flex",
            width: "100%",
            marginTop: "25px",
            flexDirection: "column",
            gap: "25px",
            backgroundColor: "#fff",
            borderRadius: "20px",
          }}
        >
          <div className="new-complaints">
            <h2 style={{ margin: "10px" }}>Today's Visitor</h2>

            <Table
              dataSource={visitor_table_data}
              columns={visitor_table_columns}
              pagination={{
                pageSize: 5,
                position: ["bottomCenter"],
                showSizeChanger: false,
              }}
              scroll={{ x: "max-content" }}
              className="society-table"
              style={{ padding: "10px" }}
            />
          </div>
        </div>

        <div className="activity-section">
          <div className="activity-header">
            <h2 className="section-title">President Activities</h2>
            <Button
              type="link"
              className="view-all-btn"
              onClick={() => setIsActivityModalOpen(true)}
            >
              View All
            </Button>
          </div>
          <div className="activity-list-preview">
            {presidentActivityDataList?.slice(0, 5)?.map((item, idx) => (
              <div key={idx} className="activity-card">
                <div className="activity-header-row">
                  <span className="activity-title">
                    {item.title || "Untitled"}
                  </span>
                  <Tag
                    color={item.action_on === "MAINTENANCE" ? "blue" : "green"}
                  >
                    {item.action_on}
                  </Tag>
                </div>
                <div className="activity-description">{item.description}</div>
                <div className="activity-footer">
                  {item.sub_type && (
                    <Tag color="purple" className="card-subtype-tag">
                      {item.sub_type
                        .toLowerCase()
                        .split("_")
                        .map(
                          (word) => word.charAt(0).toUpperCase() + word.slice(1)
                        )
                        .join(" ")}
                    </Tag>
                  )}
                  <span className="activity-date">
                    {moment(item.createdAt).format("DD MMM YYYY, hh:mm A")}
                  </span>
                </div>
              </div>
            ))}
            {presidentActivityDataList?.length === 0 && (
              <div className="no-activity">No activities found</div>
            )}
          </div>
        </div>
      </div>
      <Modal
        title="All Notifications"
        open={isActivityModalOpen}
        onCancel={handleCloseModal}
        footer={null}
        width="80%"
        style={{ top: 40 }}
        styles={{
          content: {
            padding: 0,
            maxHeight: "80vh",
            display: "flex",
            flexDirection: "column",
            borderRadius: "8px",
            overflow: "hidden",
          },
          header: {
            backgroundColor: "#f0f2f5",
            padding: "16px 24px",
            borderBottom: "1px solid #e8e8e8",
          },
          body: {
            padding: "20px",
            flexGrow: 1,
            overflowY: "auto",
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <Input.Search
          placeholder="Search by title or description..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          style={{ marginBottom: "20px", flexShrink: 0 }}
          allowClear
        />

        <div
          className="all-notifications-modal-content"
          style={{ overflowY: "auto", flexGrow: 1 }}
        >
          {paginatedActivities.length > 0 ? (
            paginatedActivities.map((item) => {
              const formattedTime = moment(item.createdAt).format("hh:mm A");
              return (
                <div
                  className="req-first req-global"
                  key={item._id}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "10px",
                    padding: "10px",
                    border: "1px solid #e8e8e8",
                    borderRadius: "8px",
                    backgroundColor: "#fff",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <div
                    className="img-cont"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "70px",
                      height: "70px",
                      backgroundColor:
                        item.sub_type === "SOCIETY_REGISTERED"
                          ? "#FFE2E599"
                          : item.sub_type === "PRESIDENT_ADDED"
                          ? "#F7EFFF"
                          : item.sub_type === "PRESIDENT_SWITCHED"
                          ? "#dcfce799"
                          : "#FFE2E599",
                      borderRadius: "50%",
                      marginRight: "15px",
                      flexShrink: 0,
                    }}
                  >
                    {item.sub_type === "SOCIETY_REGISTERED" ? (
                      <img
                        src={societies_icn}
                        alt="Society"
                        style={{ width: "45px", height: "45px" }}
                      />
                    ) : item.sub_type === "PRESIDENT_ADDED" ? (
                      <img
                        src={registrations_icn}
                        alt="President"
                        style={{ width: "45px", height: "45px" }}
                      />
                    ) : item.sub_type === "PRESIDENT_SWITCHED" ? (
                      <img
                        src={switch_icn}
                        alt="Switched"
                        style={{ width: "45px", height: "45px" }}
                      />
                    ) : (
                      <img
                        src={registrations_icn}
                        alt="Default"
                        style={{ width: "45px", height: "45px" }}
                      />
                    )}
                  </div>
                  <div className="request-text" style={{ flexGrow: 1 }}>
                    <p
                      className="req-title"
                      style={{
                        margin: 0,
                        fontSize: "16px",
                        fontWeight: "bold",
                        color: "#333",
                      }}
                    >
                      {item.title}
                    </p>
                    <p
                      className="req-desc"
                      style={{
                        margin: "5px 0 0",
                        fontSize: "14px",
                        color: "#666",
                      }}
                    >
                      {item.description}
                    </p>
                    <p
                      className="req-discription"
                      style={{
                        margin: "5px 0 0",
                        fontSize: "12px",
                        color: "#999",
                      }}
                    >
                      {moment(item.createdAt).format("DD/MM/YYYY")}
                      {",    "}
                      {formattedTime}
                    </p>
                  </div>
                </div>
              );
            })
          ) : (
            <div style={{ textAlign: "center", color: "#999", marginTop: "20px" }}>
              No notifications found.
            </div>
          )}
        </div>

        {filteredActivities.length > 0 && (
          <div
            style={{
              padding: "16px 0 0",
              textAlign: "center",
              flexShrink: 0,
              borderTop: "1px solid #e8e8e8",
              marginTop: "auto",
            }}
          >
            <Pagination
              current={currentActivityPage}
              pageSize={pageSize}
              total={filteredActivities.length}
              onChange={(page) => setCurrentActivityPage(page)}
              showSizeChanger={false}
            />
          </div>
        )}
      </Modal>
    </>
  );
};

export default DashboardComponent;
